import React from "react";
import MuiCheckbox from "@material-ui/core/Checkbox";

/**
 * OSSCheckboxCell
 * @array selections - array of strings
 * @string checkedKey - key to be included in selections
 * @function handleClick - passes back the selected row
 */
const OSSCheckboxCell = ({ row, handleClick, column }) => {
  const { selections, checkedKey, disableChecker } = column;

  const checked = selections && selections?.includes(row[checkedKey]);
  const disabled =
    disableChecker instanceof Function ? disableChecker(row) : false;

  return (
    <MuiCheckbox
      checked={checked}
      onChange={event => handleClick(row, event)}
      disabled={disabled}
    />
  );
};

export default OSSCheckboxCell;
